"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./clinic"), exports);
__exportStar(require("./concession-card"), exports);
__exportStar(require("./consultation"), exports);
__exportStar(require("./consultation-notes-history"), exports);
__exportStar(require("./document"), exports);
__exportStar(require("./ihi-review-log"), exports);
__exportStar(require("./note"), exports);
__exportStar(require("./patient"), exports);
__exportStar(require("./patient-assessment"), exports);
__exportStar(require("./prescription"), exports);
__exportStar(require("./qol"), exports);
__exportStar(require("./telecom"), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYXBpLXBtcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQXlCO0FBQ3pCLG9EQUFrQztBQUNsQyxpREFBK0I7QUFDL0IsK0RBQTZDO0FBQzdDLDZDQUEyQjtBQUMzQixtREFBaUM7QUFDakMseUNBQXVCO0FBQ3ZCLDRDQUEwQjtBQUMxQix1REFBcUM7QUFDckMsaURBQStCO0FBQy9CLHdDQUFzQjtBQUN0Qiw0Q0FBMEIiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgKiBmcm9tICcuL2NsaW5pYyc7XG5leHBvcnQgKiBmcm9tICcuL2NvbmNlc3Npb24tY2FyZCc7XG5leHBvcnQgKiBmcm9tICcuL2NvbnN1bHRhdGlvbic7XG5leHBvcnQgKiBmcm9tICcuL2NvbnN1bHRhdGlvbi1ub3Rlcy1oaXN0b3J5JztcbmV4cG9ydCAqIGZyb20gJy4vZG9jdW1lbnQnO1xuZXhwb3J0ICogZnJvbSAnLi9paGktcmV2aWV3LWxvZyc7XG5leHBvcnQgKiBmcm9tICcuL25vdGUnO1xuZXhwb3J0ICogZnJvbSAnLi9wYXRpZW50JztcbmV4cG9ydCAqIGZyb20gJy4vcGF0aWVudC1hc3Nlc3NtZW50JztcbmV4cG9ydCAqIGZyb20gJy4vcHJlc2NyaXB0aW9uJztcbmV4cG9ydCAqIGZyb20gJy4vcW9sJztcbmV4cG9ydCAqIGZyb20gJy4vdGVsZWNvbSc7XG4iXX0=